import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {GUIDE_PATH, HOME_PATH, LIST_PATH, SETTINGS_PATH} from '../../0-application/shared'
import {RoleHelper} from '../../services/role-helper'
import {Progress} from '../progress/progress'
import {MatDivider} from '@angular/material/list'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    RouterLink,
    ToggleButtonComponent,
    MatIconButton,
    Progress,
    MatDivider
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  protected readonly service = inject(ConfigService)
  protected readonly HOME_PATH = HOME_PATH
  protected readonly SETTINGS_PATH = SETTINGS_PATH
  protected readonly LIST_PATH = LIST_PATH
  protected readonly GUIDE_PATH = GUIDE_PATH

  protected readonly helper = inject(RoleHelper)
}
